import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-amende-add',
  templateUrl: './amende-add.component.html',
  styleUrls: ['./amende-add.component.scss']
})
export class AmendeAddComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
